var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.editTicket)?_c('ticket-details',{attrs:{"ticket":_vm.ticket,"loading":_vm.loading},on:{"editCard":_vm.ticketEdit}}):_c('ticket-edit',{attrs:{"ticket":_vm.ticket},on:{"editCard":_vm.ticketEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }